import * as CL from '@design-system/component-library';
import { t } from '../../../common/i18n/index.js';
import { CheckoutFooterCoCo } from './common/CheckoutFooterCoCo.js';

import './CustomerStep.scss';

export interface CustomerInfoProps {
  contactInfo: string[];
  companyName: string;
  onNext: () => void;
  onPrevious?: () => void;
}

export const CustomerStepCoCo = ({ contactInfo, companyName, onNext, onPrevious }: CustomerInfoProps) => {
  const handlePrevious = async () => {
    onPrevious?.();
  };

  return (
    <>
      <div className="of-place-order__customer-step">
        <h2>{t.NF60('Customer details')}</h2>
        <CL.Description
          items={[
            {
              title: companyName,
              description: contactInfo.map(value => <div key={value}>{value}</div>),
            },
          ]}
        />
      </div>
      <CheckoutFooterCoCo onNext={onNext} onPrevious={handlePrevious} />
    </>
  );
};
